import { EHeaderIcons } from '../types/types';

export const content = [
  {
    title: 'Застройщикам',
    titleIcon: EHeaderIcons.Developer,
    content: [
      'Темпы и параметры продаж в жилых комплексах',
      'Анонсы выхода новых проектов',
      'Инвестиционный и финансовый анализ',
      'Оперативная информация о динамике цен',
      'Данные по ценам на вторичном рынке',
      'Анализ спроса через пользовательское поведение',
    ],
  },
  {
    title: 'Ритейлерам',
    titleIcon: EHeaderIcons.Retail,
    content: [
      'Постоянный мониторинг выхода на рынок новых объектов в аренде и продаже',
      'Отслеживание трендов на рынках аренды и продажи',
      'Автоматизация подбора новых помещений',
    ],
  },
  {
    title: 'Агентствам недвижимости',
    titleIcon: EHeaderIcons.RealEstate,
    content: [
      'Сравнение доли проникновения услуги с точностью до выбранной локации',
      'Анализ доли рынка с точностью до локации',
      'Для бизнес-подразделений: мониторинг вывода новых проектов на старт продаж',
      'Точечная оценка конкуренции в каждом ЖК',
    ],
  },
  {
    title: 'Банкам',
    titleIcon: EHeaderIcons.Bank,
    content: [
      'Корпоративный бизнес: оценка застройщиков, динамика продаж, конкурентного окружения, сроков строительства и ввода в эксплуатацию (214-ФЗ)',
      'Розничный бизнес: массовая переоценка залогов (4892-У), точечная оценка залогов',
      'Оценка трендов покупательского интереса на рынке недвижимости',
    ],
  },
  {
    title: 'Страховым компаниям',
    titleIcon: EHeaderIcons.Ensuranse,
    content: [
      'Постоянный мониторинг выхода на рынок новых объектов в аренде и продаже',
      'Поиск лучших вариантов для заключения договора',
    ],
  },
];
